import { quickProperty, designToken } from '../component-tokens';
import { sizeAttributes } from './utils';
const states = [
    {
        name: 'available',
        color: designToken('icon-color-success'),
    },
    {
        name: 'busy',
        color: designToken('icon-color-danger'),
    },
    {
        name: 'away',
        color: designToken('icon-color-warning'),
    },
    {
        name: 'dnd',
        color: designToken('icon-color-default'),
    },
    {
        name: 'do-not-disturb',
        color: designToken('presence-dnd'),
    },
    {
        name: 'offline',
        color: designToken('icon-color-default'),
    },
    {
        name: 'disconnected',
        color: designToken('icon-color-default'),
    },
];
const variants = [];
states.forEach(({ name, color }) => {
    const value = {
        name,
        attributes: Object.assign(Object.assign({ color }, sizeAttributes('0.625rem')), { 'pointer-events': quickProperty('none') }),
    };
    variants.push(...[
        value,
        Object.assign(Object.assign({}, value), { name: `${name}-achromatic`, alias: 'presence-indicator-achromatic', attributes: Object.assign(Object.assign({}, value.attributes), { color: designToken('icon-color-inverted') }) }),
    ]);
});
export const presenceIndicatorTokens = {
    name: 'presence-indicator',
    tag: 'chameleon-presence-indicator',
    reactImports: 'PresenceIndicator',
    variants,
};
